import SelectMenu from "../../../controls/SelectMenu";
import FinanceProductFilters from "./FinanceProductFilters";
import type {
  FinanceProductFilterOptions,
  FinanceReportFilters,
  ReportFilterOption,
  SetFinanceReportFilters,
} from "./types";

const issueTypes: ReportFilterOption[] = [
  { value: "", label: "All issue types" },
  { value: "sales_missing_price", label: "Missing sales price" },
  { value: "sales_missing_cogs", label: "Missing sales cost" },
  { value: "sales_missing_currency", label: "Missing sales currency" },
  { value: "sales_missing_customer", label: "Missing sales customer" },
  {
    value: "production_missing_input_cost",
    label: "Missing production input cost",
  },
  {
    value: "production_missing_output_cost",
    label: "Missing production output cost",
  },
  { value: "production_incompatible_yield", label: "Incompatible yield units" },
  {
    value: "production_invalid_allocation",
    label: "Invalid production allocation",
  },
  { value: "production_no_inputs", label: "Production without inputs" },
  { value: "production_no_outputs", label: "Production without outputs" },
  { value: "production_zero_output", label: "Production with zero output" },
  {
    value: "receiving_missing_unit_cost",
    label: "Missing receiving unit cost",
  },
  {
    value: "receiving_missing_total_cost",
    label: "Missing receiving total cost",
  },
  { value: "receiving_missing_product", label: "Missing receiving product" },
  { value: "receiving_missing_quantity", label: "Missing receiving quantity" },
  { value: "receiving_missing_supplier", label: "Missing receiving supplier" },
  { value: "inventory_missing_value", label: "Missing inventory value" },
  {
    value: "inventory_missing_location",
    label: "Missing inventory location",
  },
  { value: "inventory_missing_product", label: "Missing inventory product" },
  {
    value: "inventory_open_wip_missing_cost",
    label: "Open WIP missing cost",
  },
  { value: "credit_missing_amount", label: "Missing credit amount" },
  { value: "credit_missing_customer", label: "Missing credit customer" },
  { value: "credit_missing_order_currency", label: "Missing credit currency" },
];

type Props = FinanceProductFilterOptions & {
  filters: FinanceReportFilters;
  setFilters: SetFinanceReportFilters;
};

export default function DataQualityFilters({
  filters,
  setFilters,
  products,
  classes,
  categories,
}: Props) {
  const update = (key: "issue_type", value: ReportFilterOption) =>
    setFilters({ ...filters, [key]: value });

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      <SelectMenu
        title="Issue type"
        name="issue_type"
        options={issueTypes}
        value={filters.issue_type}
        handleInputChange={(event: { target: { value: ReportFilterOption } }) =>
          update("issue_type", event.target.value)
        }
      />
      <FinanceProductFilters
        filters={filters}
        setFilters={setFilters}
        classes={classes}
        categories={categories}
        products={products}
      />
    </div>
  );
}
